import { Skeleton } from "@mui/material";
import { Stack } from "@mui/material";

export const FormInputWithLabelSkeleton = () => (
  <Stack gap={1} mb={5}>
    <Skeleton height={21} width={Math.floor(Math.random() * 150) + 30} />
    <Skeleton height={44} width="100%" variant="rounded" />
  </Stack>
);
